import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["indentation", "use", "children"];
import styled from 'foundations-theming/utils';
import { toPx } from '../../../utils/toPx';
import { filterProps } from '../../../utils/filterProps';
import { useMapTokenPropsToCSS } from '../../../hooks/useMapTokenPropsToCSS';
import { jsx as _jsx } from "react/jsx-runtime";
const INDENT_OPTIONS = {
  default: '44px',
  compact: '20px',
  none: 0
};
export const StyledExpandableContents = styled.div.withConfig({
  displayName: "ExpandableContents__StyledExpandableContents",
  componentId: "sc-1c13x6f-0"
})(({
  $indentation = 'default',
  $use,
  theme,
  $cssStyles
}) => {
  return {
    paddingBottom: theme.space['600'],
    paddingLeft: typeof $indentation === 'number' ? toPx($indentation) : INDENT_OPTIONS[$indentation],
    paddingRight: $indentation === 'none' ? 0 : theme.space['500'],
    paddingTop: $indentation === 'none' ? 0 : $use === 'enclosed' ? theme.space['500'] : theme.space['100'],
    '> :last-child': Object.assign({
      marginBottom: 0
    }, $cssStyles)
  };
});
export const ExpandableContents = _ref => {
  let {
      indentation = 'default',
      use,
      children
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    domProps,
    tokenProps
  } = filterProps(rest);
  const spaceStyles = useMapTokenPropsToCSS(tokenProps);
  return /*#__PURE__*/_jsx(StyledExpandableContents, Object.assign({
    $use: use,
    $indentation: indentation,
    $cssStyles: spaceStyles
  }, domProps, {
    children: children
  }));
};